module.exports = {"MQ_SMALL":"550px","MQ_MEDIUM":"768px","MQ_LARGE":"1024px","MQ_XLARGE":"1280px","MQ_XXLARGE":"1920px"};